import { useAuth } from '@/store/useAuth';
import { Navigate, useLocation } from 'react-router-dom';

export default function RequireAuth({ children }) {
  const isAuthenticated = useAuth((s) => s.isAuthenticated);
  const bootstrapping = useAuth((s) => s.bootstrapping);
  const location = useLocation();

  if (bootstrapping) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-white">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-slate-200 border-t-blue-600" />
      </div>
    );
  }

  if (!isAuthenticated) {
    const from = `${location.pathname}${location.search || ''}`;
    return <Navigate to="/login" state={{ from }} replace />;
  }

  return children;
}
